/**
 * LocationSlugRouter — dispatches /locations/:slug between:
 *   • ClinicLocation (when slug matches one of the five in-code clinics), and
 *   • the pre-existing CmsPage state-page renderer (for any legacy state slug
 *     that lives in the CMS).
 *
 * This preserves 100% back-compat with the older /locations/:slug/:city state
 * pages while giving the five flat clinic URLs (/locations/las-vegas-nv,
 * /locations/albuquerque-nm, etc.) precedence when they match.
 */
import { useParams } from "react-router-dom";
import ClinicLocation from "../pages/ClinicLocation";
import CmsPage from "../pages/CmsPage";
import { CLINIC_SLUGS } from "../data/clinics";

export default function LocationSlugRouter() {
  const { slug } = useParams();
  if (slug && CLINIC_SLUGS.includes(slug)) {
    return <ClinicLocation />;
  }
  return <CmsPage pageType="state" />;
}
